import React, { Component } from 'react'
import { goToByScroll } from '../../util/animation';

//Retun the card info.
const Card = props => {
    return (
        <div className="card_wrapper">
        <div className="home_card_section">
          <div className="card_container">
            <div className="card_image radio_card"><img src="../../assets/images/star.svg" className="card_icon" /></div>
            <div className="card_text">
              <h2>UBIQUITY</h2>
              <p>A mobile medium where the audience listens during drive time, evening or the afternoons during their spare time.</p>
            </div>
          </div>
          <div className="card_container">
            <div className="card_image radio_card"><img src="../../assets/images/launch.svg" className="card_icon" /></div>
            <div className="card_text">
              <h2>IMMEDIACY</h2>
              <p>Speedy dissemination of message to the market.</p>
            </div>
          </div>
          <div className="card_container">
            <div className="card_image radio_card"><img src="../../assets/images/customer-service.svg" className="card_icon" /></div>
            <div className="card_text">
              <h2>IN TOUCH</h2>
              <p>Keeps the people updated on the latest happenings/news, traffic or weather updates.</p>
            </div>
          </div>
        </div>
        <div className="home_card_section">
          <div className="card_container">
            <div className="card_image radio_card"><img src="../../assets/images/tower.svg" className="card_icon" /></div>
            <div className="card_text">
              <h2>HIGH FREQUENCY</h2>
              <p>High Frequency promos throughout the day &amp; use of multiple stations to build frequency levels for maximum impact.</p>
            </div>
          </div>
          <div className="card_container">
            <div className="card_image radio_card"><img src="../../assets/images/tap.svg" className="card_icon" /></div>
            <div className="card_text">
              <h2>CALL TO ACTION</h2>
              <p>Drives on the spot action through the direct responses received</p>
            </div>
          </div>
          <div className="card_container">
            <div className="card_image radio_card"><img src="../../assets/images/mail.svg" className="card_icon" /></div>
            <div className="card_text">
              <h2>BETTER RECALL</h2>
              <p>Creates better brand recall through constant reminders &amp; seamless creative brand integrations</p>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Card;


// WEBPACK FOOTER //
// ./web/components/home/Card_Wraper.jsx